import { isTaxInclusive } from "./helper";
import Konsole from "./konsole/Konsole";
const FilterTaxes = (item: any) => {
  const newData = structuredClone(item);

  const tax: any = [];
  let sub_total = 0;
  let tax_amount = 0;
  newData?.map((_: any) => {
    // console.log('___asdf',_)
    sub_total += Number(_.sub_total * _.quantity || 0);
    _?.tax_rate_list?.map((__: any) => {
      const index = tax.findIndex((i: any) => i.tax_name == __.tax_name);
      let newObj: any = {};
      if (index != -1) {
        newObj = tax[index];
        tax_amount += __.actual_tax_amount;
        newObj["actual_tax_amount"] =(newObj["actual_tax_amount"] || 0) + __.actual_tax_amount;
        tax.splice(index, 1, newObj);
      } else {
        tax_amount += __.actual_tax_amount;

        tax.push(__);
      }

      // @@ this is for remove tax price from exclusive tax
      if(isTaxInclusive(__.tax_inclusive_exclusive_type)){
         sub_total -= Number(__.actual_tax_amount || 0);
      }
    });
  });
  Konsole.log(sub_total);
  return { tax, sub_total, tax_amount };
};
export default FilterTaxes;
